import script from "./ElementBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./ElementBlock.vue?vue&type=script&setup=true&lang=js"

import "./ElementBlock.vue?vue&type=style&index=0&id=0e08b206&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e08b206"]])

export default __exports__